<template>
  <section id="section1">

    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-row align="center" justify="center">
          <v-col cols="12" md="9" xl="9">
            <div class="text-center mt-4">
              <h1 class="section-title font-weight-light">Наша команда экспертов</h1>
              <h4 class="section-subtitle font-weight-light">Доверьте подготовку ваших документов нашим экспертам</h4>
            </div>
          </v-col>
          <v-col cols="12" md="9" xl="9" class="mb-6 section1-cards" style="padding-left: 0; padding-right: 0;">
            <div class="row align-center justify-center">
              <div v-for="(expert, i) in experts" :key="i" class="d-flex flex-column align-center justify-center col-sm-6 col-md-6 col-lg-2 col-xl-2 col-12">

                  <v-img :eager="true" class="d-block ml-auto mr-auto" :src="expert.img" max-width="200px"></v-img>
                  <h4 class="font-weight-light   my-3 text-center fio-text">
                    {{ expert.fio }}
                  </h4>
                  <p class="text-center position-text">{{expert.position}}</p>
                  <p class="text-center work-text">{{expert.work}}</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </section>
</template>

<script>
export default {
  data() {
    return {
      experts: [
        {
          href: "",
          img: require("@/assets/experts/exp1.png"),
          fio: "Луиза Вакурова",
          position: "Эксперт",
          work: "Опыт работы: 4 лет"
        },
          {
          href: "",
          img: require("@/assets/experts/exp2.png"),
          fio: "Виктория Миронова",
          position: "Руководитель клиентского сервиса",
          work: "Опыт работы: 8 лет"
        },
          {
          href: "",
          img: require("@/assets/experts/exp3.png"),
          fio: "Наталья Левина",
          position: "Эксперт",
          work: "Опыт работы: 5 лет"
        },
          {
          href: "",
          img: require("@/assets/experts/exp4.png"),
          fio: "Кристина Артёмова",
          position: "Эксперт",
          work: "Опыт работы: 6 лет"
        },
          {
          href: "",
          img: require("@/assets/experts/exp5.png"),
          fio: "Ирина Белова",
          position: "Эксперт",
          work: "Опыт работы: 7 лет"
        },

      ]
    };
  },
};
</script>

<style lang="scss">
.fio-text{
  color: #005096 !important;
}
.position-text{
  color: #005096;
  font-size: 13px;
  font-weight: 500;
}
.work-text{
  font-size: 13px;
}
</style>
